export default "__VITE_ASSET__f146b64d__"